import { render, staticRenderFns } from "./PickUpScreen.vue?vue&type=template&id=65949ea3&scoped=true&"
import script from "./PickUpScreen.vue?vue&type=script&lang=js&"
export * from "./PickUpScreen.vue?vue&type=script&lang=js&"
import style0 from "./PickUpScreen.vue?vue&type=style&index=0&id=65949ea3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65949ea3",
  null
  
)

export default component.exports